// @ts-check
export const RANGES = {
  DAY: "date",
  WEEK: "week",
  MONTH: "month",
  CUSTOM: "custom",
}

/** @type {import("./CompoundRangeDatePicker.types").UNIFIEDDATE_VALUES} */
export const UNIFIEDDATE_VALUES = {
  DAY: "custom",
  SINGLESPRINT: "single-sprint",
  SINGLEDAY: "single-date",
  SINGLEDATETIME: "single-datetime",
  SINGLEWEEK: "single-week",
  SINGLEMONTH: "single-month",
  SINGLEYEAR: "single-year",
  RANGEDAY: "range-date",
  RANGEWEEK: "range-week",
  RANGEMONTH: "range-month",
  RANGEYEAR: "range-year",
  CUSTOM: "custom",
  SPRINT: "sprint",
  BLOCK: "block",
  CYCLE: "cycle",
}

export const UNIFIEDDATE_SELECTOR = {
  SINGLE: "single",
  RANGE: "range",
}

export const UNIFIEDDATE_RANGE = {
  DAY: "date",
  DATETIME: "datetime",
  WEEK: "week",
  MONTH: "month",
  YEAR: "year",
  SPRINT: "sprint",
}
